module.exports = __webpack_public_path__ + "img/research_4.a2e034ff.jpg";